import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { connect } from "react-redux";

const LoadingOverlay = ({ loading }) => (
    <Backdrop
      sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );

const mapStateToProps = ({ baseState }) => ({
  loading: baseState.loading
});

export default connect(mapStateToProps)(LoadingOverlay);
